if (!customElements.get('mcc-campaign-motion')) {
  customElements.define('mcc-campaign-motion', class extends HTMLElement {
    connectedCallback() {
      this.abort = new AbortController();
      this.reduced = matchMedia('(prefers-reduced-motion: reduce)');
      this.inView = false;
      this.last = new Map();
      this.digits = [...this.querySelectorAll('[data-time]')];
      this.digits.forEach(node => this.last.set(node, node.textContent));
      this.update = () => {
        const running = this.dataset.motionEnabled === 'true' && !this.reduced.matches && this.inView && !document.hidden && !this.hidden;
        this.dataset.motionRunning = String(running);
        if (!running) this.digits.forEach(node => node.getAnimations().forEach(animation => animation.cancel()));
      };
      this.reduced.addEventListener('change', this.update, {signal: this.abort.signal});
      document.addEventListener('visibilitychange', this.update, {signal: this.abort.signal});
      this.visibility = new IntersectionObserver(entries => { this.inView = entries[0].isIntersecting; this.update(); }, {threshold: 0.05});
      this.visibility.observe(this);
      this.observer = new MutationObserver(() => {
        this.digits.forEach(node => {
          const value = node.textContent;
          if (value === this.last.get(node)) return;
          this.last.set(node, value);
          if (this.dataset.motionRunning !== 'true' || this.dataset.animateDigits !== 'true') return;
          node.getAnimations().forEach(animation => animation.cancel());
          node.animate([
            {transform: 'perspective(260px) rotateX(-38deg) translateY(-4px)', opacity: 0.55},
            {transform: 'perspective(260px) rotateX(5deg) translateY(1px)', opacity: 1, offset: 0.65},
            {transform: 'perspective(260px) rotateX(0) translateY(0)', opacity: 1}
          ], {duration: 460, easing: 'cubic-bezier(.2,.8,.2,1)'});
        });
      });
      const clock = this.querySelector('mcc-countdown');
      if (clock) this.observer.observe(clock, {childList: true, subtree: true});
      this.update();
    }
    disconnectedCallback() {
      this.abort?.abort(); this.visibility?.disconnect(); this.observer?.disconnect();
      this.digits?.forEach(node => node.getAnimations().forEach(animation => animation.cancel()));
    }
  });
}
